import React from 'react'
import PropTypes from 'prop-types'
import theme from 'styles/theme'
import { Eyebrow, Body14 } from 'components/Typography'
import FormErrorMessage from '../FormErrorMessage'
import FormLabel from '../FormLabel'
import {
  Input,
  InputCheckbox,
  LabelText,
  StyledLink,
} from './FormCheckbox.style'

const FormCheckbox = ({
  label,
  value,
  name,
  handleChange,
  copy,
  linkText,
  link,
  required,
  hasError,
  errorMessage,
  isDisabled,
}) => {
  return (
    <>
      {label && (
        <FormLabel hasError={hasError} isDisabled={isDisabled}>
          <Eyebrow>{label}</Eyebrow>
        </FormLabel>
      )}
      <InputCheckbox hasError={hasError}>
        <FormLabel hasError={hasError} isDisabled={isDisabled}>
          <Input
            name={name}
            onChange={handleChange}
            isDisabled={isDisabled}
            checked={value}
            required={required}
          />
          <LabelText>
            <Body14
              as="div"
              className="form-check__label-text"
              color={theme.colors.sagedark}
              dangerouslySetInnerHTML={{ __html: copy }}
            />
          </LabelText>
        </FormLabel>

        {hasError && <FormErrorMessage errorMessage={errorMessage} />}

        {link && linkText && (
          <Body14>
            <StyledLink to={link} external>
              {linkText}
            </StyledLink>
          </Body14>
        )}
      </InputCheckbox>
    </>
  )
}

FormCheckbox.propTypes = {
  label: PropTypes.string,
  value: PropTypes.bool,
  copy: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  linkText: PropTypes.string,
  link: PropTypes.string,
  handleChange: PropTypes.func.isRequired,
  required: PropTypes.bool,
  hasError: PropTypes.bool,
  errorMessage: PropTypes.string,
  isDisabled: PropTypes.bool,
}

FormCheckbox.defaultProps = {
  label: '',
  value: false,
  linkText: '',
  link: '',
  required: false,
  hasError: false,
  errorMessage: '',
  isDisabled: false,
}

export default FormCheckbox
